import React, { useContext, useEffect, useState } from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/Phone';
import { motion } from 'framer-motion';
import '../styles/css/MobileActionBar.css';
import { LanguageContext } from '../App';

const PHONE_NUMBER = '972524636767';
const TEL_NUMBER = '+972524636767';

const MobileActionBar = () => {
  const [hidden, setHidden] = useState(false);
  const { language, translations } = useContext(LanguageContext);

  useEffect(() => {
    const targets = ['contact', 'site-footer']
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    if (!targets.length) return undefined;

    const visibleIds = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleIds.add(entry.target.id);
          } else {
            visibleIds.delete(entry.target.id);
          }
        });
        setHidden(visibleIds.size > 0);
      },
      { threshold: 0.12 }
    );

    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, []);

  const whatsappMessage = translations[language].mobileBarWhatsappMessage;
  const whatsappHref = `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <motion.div
      className={`mobile-action-bar ${hidden ? 'mobile-action-bar--hidden' : ''}`}
      dir={language === 'he' ? 'rtl' : 'ltr'}
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      <motion.a
        className="mobile-action-bar__btn mobile-action-bar__btn--whatsapp"
        href={whatsappHref}
        target="_blank"
        rel="noreferrer"
        aria-label={translations[language].mobileBarWhatsapp}
        whileTap={{ scale: 0.94 }}
      >
        <WhatsAppIcon fontSize="small" />
        <span>{translations[language].mobileBarWhatsapp}</span>
      </motion.a>
      <motion.a
        className="mobile-action-bar__btn mobile-action-bar__btn--call"
        href={`tel:${TEL_NUMBER}`}
        aria-label={translations[language].mobileBarCall}
        whileTap={{ scale: 0.94 }}
      >
        <PhoneIcon fontSize="small" />
        <span>{translations[language].mobileBarCall}</span>
      </motion.a>
    </motion.div>
  );
};

export default MobileActionBar;
